function IconBag() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
        >
            <rect width={16} height={16} fill="url(#pattern0_4121_320)" />
            <defs>
                <pattern
                    id="pattern0_4121_320"
                    patternContentUnits="objectBoundingBox"
                    width={1}
                    height={1}
                >
                    <use xlinkHref="#image0_4121_320" transform="scale(0.01)" />
                </pattern>
                <image
                    id="image0_4121_320"
                    width={100}
                    height={100}
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADy0lEQVR4nO2dz2sTQRTH14MlMy1WRQ/VUqG+iSUIHrx48S+wF6nxR95rtaDFUg9616N6Vvwr9GY9qadKtahVvOm56h9Qf4AWG5lNhXaTtCbZdN8k3w88CGEzs7Of3ZnJMC+JIgAAAKAL2FUo7rVUGjVO7hriZ4b4g3WyZJ38XIsl/55x/NQf44/tHyrtyfq8O4vjUzsN8RlD8tw6WbVOyg3GakWejPmysm5OyOywrnTFkHxtQkLNiMvK82VfdtaNC4o+4oIlfpGWiKogmfN1ZN3OILBUGrWOf2xyl7+3xPdyh/msdXLMEA9Gg0Xjw7/27+XypXOW5H58bF0p/N06PpV1e1VjnUxYkpUad/Q3S/ygd1iONlqm/4z/bFxGdbkrvcTSntYEjiE+YUl+VT0RTmZzw+NDLZd/5PwB6+RRjSfld87xyXRa0SH4qakl+ZK8UH5QT7su62Sq6ikk/tx/6OLutOsKFkN8Z+Ody3+M49Ptq0/GfB2Jsel2u+oLij6a3F8ZYDd0JTfbXa8lvpUc5PvyF/ZF3Y4lmUzcqR+35QtcodhjiT8lboRLUbeTHGgN8fXtqtuQ3Eh0lQ8jNRSKPcbJNUu8UKMLQbi0v5zG1/iVycuMv/ZVU0Lj+B0uvGRy4xkni3aEB9Y9GZBhs+8F3sZjZ9xNZX8yCBdPaKb99G8hMbA99l1YNgNZ92DcxEG/CpG49i+j5BqPPzDrk+0W1hZD188wl6Nkd5H1SXYbVdcfQrIFQpQBIcqAEGVAiDIgRBkQogwIUQaEKANClAEhyoAQZUCIMiBEGRCiDAhRBoQoA0KUASHKgBBlQIgyIEQZEKIMCFEGhCgDQpQBIcqAEGVAiDLCFVJoMAdysxw+RQQpxLSYA7kxh08X4QkppJYDWcnhU0ZwQkyKOZBxDl9oQrSltNkmcyDr5vApTmmrI0RmNUmxLeRA1szhU4I/N0PyZEsh2iNqkODal/UJQIhAiA3qCSGZq/n7hEoi6pQuK/4dSZnbUkikDEO83ImD+j+CE2IT097/nQXWnsXomvYGKcTkZSatbsLQ+NVIGcEJiSqLiosp9NmvsXSSEnaEB/xaVPMy+A0WF9vyLwkybR3P/9csMD6G5+NuSuGiYrhdVocDIcqAEGVAiDIgRBkQogwIUQaEKANClAEhyoAQZUCIMiBEGRCiDAhRBoQoA0KUASHKgBBlQIgyIEQZEKJdSCt7Z0E7/hSsyb2zoDXq7j1Oc+8sQlLYe5zW3llEObW9xy3vnUWUW5NRa+9xo3tnEeUWn4gg9h4DAACIguEv+x80D7DXg4gAAAAASUVORK5CYII="
                />
            </defs>
        </svg>


    )
}

export default IconBag
